import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import HeaderEditModal from "./HeaderEditModal";

function HeaderImages() {
    const navigate = useNavigate();
    const [headers, setHeaders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [q, setQ] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleEdit = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    // Axios auth sekali saja
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;
        axios.interceptors.request.use(
            (config) => {
                config.headers.authorization = token;
                return config;
            },
            (error) => Promise.reject(error)
        );
    }, []);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }
            setLoading(true);
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/header`);
            setHeaders(Array.isArray(data) ? data : []);
        } catch (e) {
            console.error(e);
            Swal.fire("Gagal", "Tidak dapat memuat data header.", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // ======= UI Helpers =======
    const focusLabel = (pos) =>
        ({ top: "Atas", center: "Tengah", bottom: "Bawah" }[pos || "center"]);

    const filtered = useMemo(() => {
        if (!q) return headers;
        const s = q.toLowerCase();
        return headers.filter(
            (h) =>
                (h.page_slug || "").toLowerCase().includes(s) ||
                (h.title || "").toLowerCase().includes(s)
        );
    }, [headers, q]);

    // ======= Columns =======
    const columns = [
        { name: "No", selector: (_r, i) => i + 1, width: "70px" },
        {
            name: "Halaman",
            selector: (r) => r.page_slug,
            sortable: true,
            width: "160px",
            cell: (r) => (
                <span className="badge badge-light" style={{ fontWeight: 600 }}>
                    {r.page_slug}
                </span>
            ),
        },
        {
            name: "Judul",
            selector: (r) => r.title || "-",
            sortable: true,
            grow: 2,
            cell: (r) => (
                <div style={{ lineHeight: 1.3 }}>
                    <div style={{ fontWeight: 600 }}>{r.title || "-"}</div>
                    <div style={{ fontSize: 12, color: "#6b7280" }}>
                        Fokus: {focusLabel(r.focus_position)} • {r.active ? "Aktif" : "Nonaktif"}
                    </div>
                </div>
            ),
        },
        {
            name: "Preview",
            width: "200px",
            cell: (r) => (
                <div
                    title={r.image_url || "Belum ada gambar"}
                    style={{
                        width: 170,
                        height: 96,
                        borderRadius: 8,
                        border: "1px solid #e5e7eb",
                        background: r.image_url
                            ? `url('${r.image_url}') ${
                                  r.focus_position || "center"
                              } / cover no-repeat`
                            : "linear-gradient(135deg,#f3f4f6,#fff)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#9ca3af",
                        fontSize: 12,
                    }}
                >
                    {r.image_url ? "" : "No image"}
                </div>
            ),
        },
        {
            name: "Aksi",
            width: "110px",
            cell: (r) => (
                <button
                    className="btn btn-sm btn-warning"
                    onClick={() => handleEdit(r)}
                    title="Edit header"
                >
                    <i className="nav-icon fas fa-edit" /> Edit
                </button>
            ),
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Image Header</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">Data Header Images</h3>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={filtered}
                                    pagination
                                    progressPending={loading}
                                    highlightOnHover
                                    pointerOnHover
                                    noDataComponent={
                                        <div className="text-muted py-4">Belum ada data.</div>
                                    }
                                    customStyles={{
                                        headCells: {
                                            style: {
                                                backgroundColor: "#f8fafc",
                                                fontWeight: 700,
                                                fontSize: 13,
                                            },
                                        },
                                        rows: {
                                            style: { minHeight: "64px" },
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <HeaderEditModal
                show={showModal}
                row={selectedRow}
                onClose={() => setShowModal(false)}
                onSaved={fetchData}
            />
        </div>
    );
}

export default HeaderImages;
